export interface ILinkedModel {
    id: string;
    fileName: string;
    urn: string;
    status: ModelTranslationStatus;
    origin: THREE.Vector3;
    createdAt: Date;
    translationProgressPercentage: number;
}

export type LinkedModelExtension = "rvt" | "ifc";

export enum ModelTranslationStatus {
    Created = 1,
    Ready = 2,
    Failed = 3,
}
